// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const SdkRequestShape = {
    justRequestBody: (value) => {
        return {
            value: value,
            type: "justRequestBody",
            _visit: function (visitor) {
                return FernIr.SdkRequestShape._visit(this, visitor);
            },
        };
    },
    wrapper: (value) => {
        return Object.assign(Object.assign({}, value), { type: "wrapper", _visit: function (visitor) {
                return FernIr.SdkRequestShape._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "justRequestBody":
                return visitor.justRequestBody(value.value);
            case "wrapper":
                return visitor.wrapper(value);
            default:
                return visitor._other(value);
        }
    },
};
